export const BACKGROUND = {
    blue: "#008CFF",
    gray: "#9CA3AF",
    darkblue: "#007ACC"
};

export const FONTSIZE = {
    h1: "24px",
    h2: "16px",
    bigP: "15px",
    smallP: "14x",
    tinyP: "12px"
};

export const FONTCOLOR = {
    black:"#17191A",
    kindablack: "#1A202C",
    fadedblack: "26282A",
    gray: "#9CA3AF",
    darkgray: "#61666B",
    white: "#FFF"
};

export const FONTWEIGHT = {
    normal: 300,
    semibold: 400,
    almostbold: 500,
    bold: 600,
    superbold: 700
};